import { render, staticRenderFns } from "./ModelCreator.vue?vue&type=template&id=da65712c&scoped=true"
import script from "./ModelCreator.vue?vue&type=script&lang=js"
export * from "./ModelCreator.vue?vue&type=script&lang=js"
import style0 from "./ModelCreator.vue?vue&type=style&index=0&id=da65712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da65712c",
  null
  
)

export default component.exports